import { useLayoutEffect } from 'react';

// The inline-support bar spans full width by default (bottom:0, left:0, right:0), matching
// pages with no docked side panel. But #main (the app shell's grid content column) shrinks
// whenever a right-docked panel (e.g. live-chat/copilot) is open — its `1fr` grid track
// always absorbs exactly the space NOT used by that panel, purely via CSS grid auto-sizing.
// Mirror #main's right edge so our bar never extends into the panel's reserved space, without
// needing to know anything about the panel itself (open/closed state, width, or whether it exists).
export const useAlignTailToMain = (active, barRef) => {
  useLayoutEffect(() => {
    if (!active) return undefined;
    const mainEl = document.getElementById('main');
    const barEl = barRef.current;
    if (!mainEl || !barEl) return undefined;
    const align = () => {
      const gap = window.innerWidth - mainEl.getBoundingClientRect().right;
      barEl.style.right = `${Math.max(gap, 0)}px`;
    };
    align();
    const observer = new ResizeObserver(align);
    observer.observe(mainEl);
    window.addEventListener('resize', align);
    return () => { observer.disconnect(); window.removeEventListener('resize', align); };
  }, [active, barRef]);
};
